import { render, staticRenderFns } from "./remindResponseRecord.vue?vue&type=template&id=f62ad4fc&scoped=true&"
import script from "./remindResponseRecord.vue?vue&type=script&lang=js&"
export * from "./remindResponseRecord.vue?vue&type=script&lang=js&"
import style0 from "./remindResponseRecord.vue?vue&type=style&index=0&id=f62ad4fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f62ad4fc",
  null
  
)

export default component.exports